export default "__VITE_ASSET__tHD4KRWb__"